import React from 'react'
import BreadCrumbsPage from '../../components/BreadCrumbsPage'
import ComingSoon from '../../components/ComingSoon'

const AudytLLM = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b border-slate-200 px-8 py-6 shadow-sm">
        <div className="max-w-full">
          <h1 className="text-2xl font-semibold text-slate-900">Audyt AI</h1>
          <p className="text-sm text-slate-600 mt-1">AI-powered ESG analysis and insights</p>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-8">
          <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-12">
            <ComingSoon />
          </div>
        </div>
      </BreadCrumbsPage>
    </div>
  )
}

export default AudytLLM